export default "__VITE_ASSET__20483cc2__"